import type { HomeLayout } from '@almanac/shared';
import { useCurrentUser, useSetHomeLayout } from '../lib/me.js';

/**
 * Settings control for the per-user home layout (see IDEAS.md
 * "Home layout"). Two mutually-exclusive options, persisted on the
 * user row via `PATCH /api/shared/me` so the choice follows the user
 * across devices. Selecting an option flips the Today screen
 * immediately (the mutation patches the `me` cache optimistically).
 */

const OPTIONS: { value: HomeLayout; title: string; desc: string }[] = [
  {
    value: 'summary',
    title: 'Summary + tiles',
    desc: "Today's obligations panel, with compact section tiles.",
  },
  {
    value: 'tiles',
    title: 'Tiles only',
    desc: 'Large section tiles, no panel.',
  },
];

export function HomeLayoutSection() {
  const me = useCurrentUser();
  const setLayout = useSetHomeLayout();
  const current: HomeLayout = me.data?.homeLayout ?? 'summary';

  return (
    <div className="home-layout">
      <span className="reminder-toggle__heading">Home layout</span>
      <div className="home-layout-options" role="radiogroup" aria-label="Home layout">
        {OPTIONS.map((o) => {
          const selected = current === o.value;
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`home-layout-option${selected ? ' home-layout-option--selected' : ''}`}
              onClick={() => {
                if (!selected) setLayout.mutate(o.value);
              }}
            >
              <span className="home-layout-option__radio" aria-hidden="true" />
              <span className="home-layout-option__text">
                <span className="home-layout-option__title">{o.title}</span>
                <span className="home-layout-option__desc">{o.desc}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
